import { UploadedDocumentInfo } from '@urbanx/agx-ui-components';
import CampaignsService from 'services/campaignsService';

export type DocumentGroup = {
  title: string;
  documents: UploadedDocumentInfo[];
};

const GetDocumentsForCampaign = async (
  getAuthToken: () => Promise<string>,
  campaignId?: string
): Promise<DocumentGroup[] | undefined> => {
  if (!campaignId) return;

  const token = await getAuthToken();

  const service = new CampaignsService(token);

  const result = await service.campaignsService.get('StaffGetDocumentsForCampaign', { campaignId });

  return result.data;
};

export default GetDocumentsForCampaign;
